export enum Role {
  MBKC_ADMIN = 'MBKC Admin',
  BRAND_MANAGER = 'Brand Manager',
  KITCHEN_CENTER_MANAGER = 'Kitchen Center Manager',
  CASHIER = 'Cashier',
}
